import { DocumentInput } from "./general";
import { OperatorGamePopulated } from "./game";
import { GeneralMomentClient, OperatorMoment } from "./moment";

export enum ACTIONS {
  JOIN_OPERATOR_LOBBY = "JOIN_OPERATOR_LOBBY",
}

export const OPERATOR_LOBBY = "OPERATOR_LOBBY";

export enum MOMENT_EMITTER_ACTIONS {
  MOMENT_CREATED = "MOMENT_CREATED",
  GENERAL_MOMENT_CREATED = "GENERAL_MOMENT_CREATED",
  GENERAL_MOMENT_UPDATED = "GENERAL_MOMENT_UPDATED",
  /** New or updated admin ↔ operator chat message
   *  (payload: {@link AdminOperatorChatMessageEvent}). */
  ADMIN_OPERATOR_CHAT_MESSAGE = "ADMIN_OPERATOR_CHAT_MESSAGE",
  /** Thread closed or reopened by a super admin
   *  (payload: {@link AdminOperatorChatThreadStateEvent}). */
  ADMIN_OPERATOR_CHAT_THREAD_STATE = "ADMIN_OPERATOR_CHAT_THREAD_STATE",
}

export enum ERROR {
  UNKNOWN,
}

export interface ErrorData {
  errorId: ERROR;
  error?: any;
}

export interface MomentCreatedEvent {
  momentId: string;
  stadiumId: string;
}

export interface MomentCreatedEventResponse {
  game: DocumentInput;
  moment: OperatorMoment;
}

export interface GeneralMomentCreatedEvent {
  generalMomentId: string;
  stadiumId: string;
}

export interface GeneralMomentCreatedEventResponse {
  generalMoment: GeneralMomentClient;
  /** Usually full operator game (teams, logos, assignedOperators). Falls back to `{ _id }`
   *  if populate fails. */
  game: OperatorGamePopulated | DocumentInput;
}

export interface GeneralMomentUpdatedEvent {
  generalMomentId: string;
  momentId: string;
}

export interface GeneralMomentUpdatedEventResponse {
  moment: OperatorMoment;
  generalMomentId: DocumentInput;
  /** When the ongoing game can be resolved (same shape as GENERAL_MOMENT_CREATED). */
  game?: OperatorGamePopulated | DocumentInput;
}

/** Emitted to {@link OPERATOR_LOBBY} when an admin chat message is persisted. */
export interface AdminOperatorChatMessageEvent {
  /** True when this emit is only a reaction change (no new chat line). */
  isReactionUpdate?: boolean;
  message: {
    _id: string;
    threadKey: string;
    operatorEmail: string;
    gameId: string | null;
    gameLabel: string;
    fromEmail: string;
    /** Operator portal profile name for {@link fromEmail}. */
    fromDisplayName?: string;
    fromRole: "operator" | "superAdmin";
    body: string;
    attachmentUrls?: string[];
    createdAt: string;
    reactions?: {
      fromEmail: string;
      fromDisplayName: string;
      kind: "thumbsUp" | "thumbsDown" | "emphasize" | "haha" | "question";
    }[];
  };
}

export interface AdminOperatorChatThreadStateEvent {
  threadKey: string;
  closed: boolean;
  /** When true, the thread and all messages were removed permanently. */
  deleted?: boolean;
}
